export const getLanguageName = (langCode: string) => {
  const languageList: { [key: string]: string } = {
    ab: "Abkhazian",
    aa: "Afar",
    af: "Afrikaans",
    ak: "Akan",
    sq: "Albanian",
    am: "Amharic",
    ar: "Arabic",
    an: "Aragonese",
    hy: "Armenian",
    as: "Assamese",
    av: "Avaric",
    ae: "Avestan",
    ay: "Aymara",
    az: "Azerbaijani",
    bm: "Bambara",
    ba: "Bashkir",
    eu: "Basque",
    be: "Belarusian",
    bn: "Bengali",
    bh: "Bihari",
    bi: "Bislama",
    bs: "Bosnian",
    br: "Breton",
    bg: "Bulgarian",
    my: "Burmese",
    ca: "Catalan",
    ch: "Chamorro",
    ce: "Chechen",
    zh: "Chinese",
    cu: "Church Slavic",
    cv: "Chuvash",
    kw: "Cornish",
    co: "Corsican",
    cr: "Cree",
    hr: "Croatian",
    cs: "Czech",
    da: "Danish",
    dv: "Divehi",
    nl: "Dutch",
    dz: "Dzongkha",
    en: "English",
    eo: "Esperanto",
    et: "Estonian",
    ee: "Ewe",
    fo: "Faroese",
    fj: "Fijian",
    fi: "Finnish",
    fr: "French",
    ff: "Fulah",
    gl: "Galician",
    ka: "Georgian",
    de: "German",
    el: "Greek",
    gn: "Guarani",
    gu: "Gujarati",
    ht: "Haitian",
    ha: "Hausa",
    he: "Hebrew",
    hz: "Herero",
    hi: "Hindi",
    ho: "Hiri Motu",
    hu: "Hungarian",
    is: "Icelandic",
    io: "Ido",
    ig: "Igbo",
    id: "Indonesian",
    ia: "Interlingua",
    ie: "Interlingue",
    iu: "Inuktitut",
    ik: "Inupiaq",
    ga: "Irish",
    it: "Italian",
    ja: "Japanese",
    jv: "Javanese",
    kl: "Kalaallisut",
    kn: "Kannada",
    ks: "Kashmiri",
    kk: "Kazakh",
    km: "Khmer",
    ki: "Kikuyu",
    rw: "Kinyarwanda",
    ky: "Kirghiz",
    kv: "Komi",
    kg: "Kongo",
    ko: "Korean",
    kj: "Kuanyama",
    ku: "Kurdish",
    lo: "Lao",
    la: "Latin",
    lv: "Latvian",
    li: "Limburgish",
    ln: "Lingala",
    lt: "Lithuanian",
    lu: "Luba-Katanga",
    lb: "Luxembourgish",
    mk: "Macedonian",
    mg: "Malagasy",
    ms: "Malay",
    ml: "Malayalam",
    mt: "Maltese",
    gv: "Manx",
    mi: "Maori",
    mr: "Marathi",
    mh: "Marshallese",
    mn: "Mongolian",
    na: "Nauru",
    nv: "Navajo",
    nd: "North Ndebele",
    nr: "South Ndebele",
    ng: "Ndonga",
    ne: "Nepali",
    no: "Norwegian",
    nb: "Norwegian Bokmål",
    nn: "Norwegian Nynorsk",
    ii: "Nuosu",
    oc: "Occitan",
    oj: "Ojibwa",
    or: "Oriya",
    om: "Oromo",
    os: "Ossetian",
    pi: "Pali",
    ps: "Pashto",
    fa: "Persian",
    pl: "Polish",
    pt: "Portuguese",
    pa: "Punjabi",
    qu: "Quechua",
    ro: "Romanian",
    rm: "Romansh",
    rn: "Rundi",
    ru: "Russian",
    sm: "Samoan",
    sg: "Sango",
    sa: "Sanskrit",
    sc: "Sardinian",
    sr: "Serbian",
    sn: "Shona",
    sd: "Sindhi",
    si: "Sinhala",
    sk: "Slovak",
    sl: "Slovenian",
    so: "Somali",
    st: "Southern Sotho",
    es: "Spanish",
    su: "Sundanese",
    sw: "Swahili",
    ss: "Swati",
    sv: "Swedish",
    tl: "Tagalog",
    ty: "Tahitian",
    tg: "Tajik",
    ta: "Tamil",
    tt: "Tatar",
    te: "Telugu",
    th: "Thai",
    bo: "Tibetan",
    ti: "Tigrinya",
    to: "Tonga",
    ts: "Tsonga",
    tn: "Tswana",
    tr: "Turkish",
    tk: "Turkmen",
    tw: "Twi",
    ug: "Uighur",
    uk: "Ukrainian",
    ur: "Urdu",
    uz: "Uzbek",
    ve: "Venda",
    vi: "Vietnamese",
    vo: "Volapük",
    wa: "Walloon",
    cy: "Welsh",
    wo: "Wolof",
    xh: "Xhosa",
    yi: "Yiddish",
    yo: "Yoruba",
    za: "Zhuang",
    zu: "Zulu",
  };

  return languageList[langCode];
};

export const getLanguageNativeName = (langCode: string) => {
  const languageNativeName: { [key: string]: string } = {
    af: "Afrikaans",
    sq: "Albanian",
    am: "Amharic",
    ar: "العربية",
    hy: "Armenian",
    az: "Azerbaijani",
    eu: "Basque",
    be: "Belarusian",
    bn: "Bengali",
    bs: "Bosnian",
    bg: "Bulgarian",
    ca: "Catalan",
    ce: "Cebuano",
    "zh-TW": "繁體中文",
    zh: "繁體中文",
    "zh-CN": "简体中文",
    co: "Corsican",
    hr: "Croatian",
    cs: "Czech",
    da: "Danish",
    nl: "Nederlands",
    en: "English",
    eo: "Esperanto",
    et: "Estonian",
    fi: "Finnish",
    fr: "français",
    fy: "Frisian",
    gl: "Galician",
    ka: "Georgian",
    de: "Deutsch",
    el: "Greek",
    gu: "Gujarati",
    ht: "Haitian Creole",
    ha: "Hawaiian",
    he: "Hebrew",
    hi: "हिन्दी, हिंदी",
    hm: "Hmong",
    hu: "Hungarian",
    is: "Icelandic",
    ig: "Igbo",
    id: "Bahasa Indonesia",
    ga: "Irish",
    it: "Italiano",
    ja: "日本語",
    jw: "Javanese",
    kn: "Kannada",
    kk: "Kazakh",
    km: "Khmer",
    ko: "한국어",
    ku: "Kurdish",
    ky: "Kyrgyz",
    lo: "Lao",
    la: "Latin",
    lv: "Latvian",
    lt: "Lithuanian",
    lb: "Luxembourgish",
    mk: "Macedonian",
    mg: "Malagasy",
    ms: "Bahasa Melayu",
    ml: "Malayalam",
    mt: "Maltese",
    mi: "Maori",
    mr: "Marathi",
    mn: "Mongolian",
    my: "မြန်မာဘာသာ",
    ne: "Nepali",
    no: "Norwegian",
    ny: "Nyanja (Chichewa)",
    ps: "Pashto",
    fa: "Persian",
    pl: "Polish",
    pt: "Portuguese (Portugal, Brazil)",
    pa: "Punjabi",
    ro: "Romanian",
    ru: "русский язык",
    sm: "Samoan",
    gd: "Scots Gaelic",
    sr: "Serbian",
    st: "Sesotho",
    sn: "Shona",
    sd: "Sindhi",
    si: "Sinhala (Sinhalese)",
    sk: "Slovak",
    sl: "Slovenian",
    so: "Somali",
    es: "Español",
    su: "Sundanese",
    sw: "Swahili",
    sv: "Swedish",
    tl: "Tagalog (Filipino)",
    tg: "Tajik",
    ta: "Tamil",
    te: "Telugu",
    th: "ไทย",
    tr: "Turkish",
    uk: "Ukrainian",
    ur: "Urdu",
    uz: "Uzbek",
    vi: "Tiếng Việt",
    cy: "Welsh",
    xh: "Xhosa",
    yi: "Yiddish",
    yo: "Yoruba",
    zu: "Zulu",
  };

  return languageNativeName[langCode];
};

export const SCAN_QR_BANNER_MESSAGE: Record<string, string> = {
  en: "Re-scan QR Code in your room to access room request!",
  "zh-CN": "在您的房间重新扫描二维码以访问房间请求！",
  zh: "在您的房間重新掃描二維碼以訪問房間請求！",
  ko: "객실 요청을 하려면 객실 내 QR 코드를 다시 스캔하세요!",
  ja: "部屋のリクエストにアクセスするために部屋のQRコードを再スキャンしてください！",
  ru: "Сканируйте QR-код в вашей комнате для доступа к запросу комнаты!",
  th: "สแกนรหัส QR ในห้องของคุณใหม่เพื่อเข้าถึงคำขอห้อง!",
  id: "Pindai kode QR di kamar Anda lagi untuk mengakses permintaan kamar!",
  ms: "Imbas semula Kod QR di bilik anda untuk mengakses permintaan bilik!",
  my: "အခန်းတောင်းဆိုချက်ကိုဝင်ရောက်ရန် သင့်အခန်းရှိ QR ကုဒ်ကို ပြန်လည် စကန်ပါ။",
  fr: "Rescannez le code QR dans votre chambre pour accéder à la demande de chambre !",
  de: "Scannen Sie den QR-Code in Ihrem Zimmer erneut, um die Zimmeranfrage zuzugreifen!",
  it: "Riscansiona il codice QR nella tua stanza per accedere alla richiesta della stanza!",
  ar: "قم بإعادة مسح رمز الاستجابة السريعة في غرفتك للوصول إلى طلب الغرفة!",
};
